import { createState } from "@/state.init";
import { UseLoading } from "@/common/composition/loading";
import * as api from "./api";
import { SEED } from "./models";
import { emptyFn, onNewValueOnly } from "@/fp";
import { computed, Ref, watch } from "@vue/composition-api";
import { SharedState } from "@/common/state";

const { action, getter, m, attachToRouter } = createState("detection", SEED);

let timeFrameWatcherSub = emptyFn();

attachToRouter({
  listenToRoutes: [
    "InformationRisk",
    "DetectionDrillDown",
    "DetectionInsights",
  ],
  onEnter: () => {
    timeFrameWatcherSub = watch(
      SharedState.selectedTimeFrameDisplayName,
      onNewValueOnly<string>(
        (s1: string, s2: string) => s1 == s2 || !s2,
        (t1) => {
          SharedState.onReady(() => {
            loadDashboard(true);
          });
        }
      )
    );
  },
  onLeave: () => {
    timeFrameWatcherSub();
  },
});

// === LOADING ===
const { isLoading, setLoading } = UseLoading(true);
// === DASHBOARD ===
const dashboard = getter((s) => s.dashboard);
const setDashboardData = m.set("dashboard");

const regulated = getter((s) => s.regulated);
const setRegulatedData = m.set("regulated");

const pii_items = getter((s) => s.pii_items);
const setPIIData = m.set("pii_items");

let isInit = false;

const loadDashboard = action<boolean>(
  "load dashboard",
  async ({ mutate }, force = false) => {
    if (!isInit || force) {
      //  SharedState.updateInsightsCounters();
      mutate(setLoading, true);
      const regulated_data_res = await api.get_regulated_data();
      const res = await api.getDashboardData([
        ...SharedState.non_regulated_l0InfoTypes.value,
      ]);
      if (res.success && regulated_data_res.success) {
        mutate(setDashboardData, res.value);
        // @ts-ignore
        mutate(setRegulatedData, regulated_data_res.value);
      }
      if (SharedState.FeatureHelper.is_enabled("pii_labeler")) {
        const pii_res = await api.get_pii_data();
        if (pii_res.success) {
          console.log("pii_res.value:", pii_res.value);
          mutate(setPIIData, pii_res.value);
        }
      }
      mutate(setLoading, false);
      isInit = true;
    }
  }
);

// === DASHBOARD TOTAL ===
const dashboardTotal = computed(() => {
  return dashboard.value.reduce(
    (acc, { low, medium, high }) => {
      acc.high += high;
      acc.medium += medium;
      acc.low += low;
      return acc;
    },
    { high: 0, medium: 0, low: 0 }
  );
});

// {infoTypeId:totalCount}
const infoTypesTotal: Ref<{ [key: number]: number }> = computed(() => {
  return dashboard.value
    .map((item) => {
      const { high, id, low, medium } = item;
      const total = high + low + medium;
      return { total, id };
    })
    .reduce((acc, item) => {
      acc[item.id] = item.total;
      return acc;
    }, {} as { [key: string]: number });
});

const displayRisks = getter((s) => s.displayRisks);
const _toggleDisplay = m.toggle("displayRisks");
const toggleDisplay = action<void>("toggle display", async ({ mutate }) => {
  // @ts-ignore
  mutate(_toggleDisplay);
});

export const detectionState = {
  loadDashboard,
  isLoading,
  dashboard,
  pii_items,
  regulated,
  dashboardTotal,
  infoTypesTotal,
  displayRisks,
  toggleDisplay,
};
